import { Paginated } from "@/@types/generics/paginated";
import { Problem } from "@/@types/esus/Problem";
import { esusApi } from "../api";

type ProblemParams = {
	uf: string;
	ibgeCode: string;
	cnes: string;
	cids: string[] | null;
	ciaps: string[] | null;
	youngerAge: number;
	olderAge: number;
	startDate: string;
	endDate: string;
	cns: string;
	gender: string;
	professionalCategory: string;
	pageNumber: number;
	pageSize?: number;
};
export async function getProblemsPaginated({ uf, ibgeCode, ...problemParams }: ProblemParams) {
	const response = await esusApi.get<Paginated<Problem>>(
		`/uf/${uf}/city/${ibgeCode}/Problem/Get`,
		problemParams
	);
	return response.data || ({} as Paginated<Problem>);
}
